//libs
import React, { memo } from 'react';
import useTheme from '@nykaa/ui-components/themes/hooks/useTheme';
import isEmpty from 'lodash/isEmpty';

//styles
import { HeaderText, HeaderIcon, HeaderContainer, HeaderDetails } from './styles';

// icons
import { useStoreIcon, IconName } from 'shared/icons';

//defs
import { Theme } from '@nykaa/ui-components/themes/types';

interface IProductHeaderProps {
  headerDetails: Listing.IProductHeader | undefined;
}

const ProductHeader = ({ headerDetails }: IProductHeaderProps) => {
  const theme: Theme = useTheme();
  const LeavesIcon = useStoreIcon(IconName.LEAVES);

  if (isEmpty(headerDetails) || headerDetails === undefined) return null;
  const { bgColor = '', titleColor = '', title = '' } = headerDetails;
  return (
    <HeaderContainer background={bgColor}>
      <HeaderDetails data-test="header-details">
        <HeaderIcon data-test="header-icon">
          <LeavesIcon color={theme.colors.white} />
        </HeaderIcon>
        <HeaderText color={titleColor} data-test="header-text">
          {title}
        </HeaderText>
      </HeaderDetails>
    </HeaderContainer>
  );
};

export default memo(ProductHeader);
